import { EuiGlobalToastList } from '@equipmentshare/ds2'
import { Toast } from '../../types/toast'
import { useToastState, useToastDispatch } from '../../contexts/toasts/toast-context'
import { GLOBAL_TOAST_DURATION_MS } from '../../config/toasts'

export default function LegacyToasts() {
	const toasts = useToastState()
	const dispatch = useToastDispatch()

	const removeToast = ( toastToRemove: Toast ) => {
		dispatch( {
			type: 'removeToast',
			payload: toastToRemove,
		} )
	}

	return (
		<EuiGlobalToastList
			toasts={toasts}
			toastLifeTimeMs={GLOBAL_TOAST_DURATION_MS}
			dismissToast={( toast ) => removeToast( toast as Toast )}
		/>
	)
}
